import { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { useController } from "react-hook-form";

export function CardSelect({ name, control, options = [], label }) {
  const {
    field: { value, onChange },
  } = useController({ name, control });

  return (
    <div className="w-full">
      {label && (
        <span className="block text-sm font-medium text-gray-700">{label}</span>
      )}

      <Listbox value={value} onChange={onChange} by="id">
        {({ open }) => (
          <div className="relative mt-2">
            <Listbox.Button className="relative w-full cursor-default rounded-lg border border-gray-300 bg-white py-3 pl-4 pr-10 text-left shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-colors">
              <div className="flex items-center">
                {value?.icon && <span className="mr-3">{value.icon}</span>}
                <div className="flex flex-col truncate">
                  <span className="text-gray-900 truncate">
                    {value?.name || "Select a card"}
                  </span>
                  {value?.labelSub && (
                    <span className="text-gray-500 text-sm mt-0.5 truncate">
                      {value.labelSub}
                    </span>
                  )}
                </div>
              </div>
              <span className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <ChevronUpDownIcon className="h-5 w-5 text-gray-400" />
              </span>
            </Listbox.Button>

            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 w-full bg-white shadow-md max-h-60 rounded-lg py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                {options.map((option, i) => (
                  <Listbox.Option key={i} value={option}>
                    {({ active, selected }) => (
                      <div
                        className={`cursor-pointer select-none relative py-2 px-4 flex items-center rounded-lg transition-colors
                    ${active ? "bg-blue-50 text-blue-900" : "text-gray-900"}
                    ${selected ? "bg-blue-100 text-blue-800 font-medium" : ""}`}
                      >
                        {option.icon && (
                          <span className="mr-3">{option.icon}</span>
                        )}
                        <div className="flex flex-col truncate">
                          <span className="block truncate">{option.name}</span>
                          {option.labelSub && (
                            <span
                              className={`block text-sm truncate text-gray-500`}
                            >
                              {option.labelSub}
                            </span>
                          )}
                        </div>
                        {selected && (
                          <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600">
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        )}
                      </div>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        )}
      </Listbox>
    </div>
  );
}
